import React, { useState, useEffect, useCallback } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCodeBranch, faEdit } from "@fortawesome/free-solid-svg-icons";
import { withAppHOC } from "../../../hoc";
import PageHeading from "../../../components/PageHeader/PageHeader";
import LoadingSpinner from "../../../components/LoadingSpinner/LoadingSpinner";
import NoData from "../../../components/NoData/NoData";
import {
  CustomConfirmButton,
  MessageBox,
  Form,
  Fieldset,
  Button,
  ResetButton,
  Dropdown,
  Label,
  CustomButton,
  TextInput,
  NumberInput,
} from "../../../components/FormElements";
import { TableBuilder } from "../../../components/TableElements";
import {
  StyledLink,
  StyledIconTitleContainer,
  StyledIconContainer,
  StyledTitleContainer,
  StyledSpan,
  StyledFiltersContainer,
  StyledModalContainer,
  StyledApiCallLogsContainer,
} from "../../../components/Styled";
import { Image } from "../../../components/Image";
import Pagination from "../../../components/Pagination/Pagination";
import API from "../../../api";
import { API_RESPONSE_TYPES, PERMISSION_TYPES } from "../../../constants";
import {
  getSearchParams,
  formatCurrency,
  shouldRedirect,
  redirectToPageOne,
} from "../../../utils";
import FiltersButton from "../../../components/FiltersButton/FiltersButton";
import Modal from "../../../components/Modal";
import { Grid, GridItem } from "../../../components/Grid";
import OverlayLoader from "../../../components/OverlayLoader/OverlayLoader";
import { isEmpty } from "lodash";

const APISwitchingTable = (props) => {
  const {
    appData: { accessType },
  } = props;
  const [paginationData, setPaginationData] = useState({
    pageNumber: getSearchParams("pageNumber") || 1,
    recordsPerPage: getSearchParams("recordsPerPage") || 10,
  });
  const [totalRecords, setTotalRecords] = useState(0);
  const [isFiltering, setIsFiltering] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [responseStatus, setResponseStatus] = useState("");
  const [responseMessage, setResponseMessage] = useState("");
  const [apiSwitching, setApiSwitching] = useState([]);
  const [services, setServices] = useState([]);
  const [operators, setOperators] = useState([]);
  const [apiProviders, setApiProviders] = useState([]);
  const [servicesId, setServicesId] = useState("");
  const [operatorsId, setOperatorsId] = useState("");
  const [apiProvidersId, setApiProvidersId] = useState("");

  const [showModal, setShowModal] = useState(false);
  const [switchingsId, setSwitchingsId] = useState("");
  const [switchingsObject, setSwitchingsObject] = useState(null);
  const [switchingType, setSwitchingType] = useState("Dynamic");
  const [enableSwitchingBackup, setEnableSwitchingBackup] = useState("Yes");
  const [switchings, setSwitchings] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [profitOnly, setProfitOnly] = useState("No");

  const resetForm = () => {
    setServicesId("");
    setOperatorsId("");
    setApiProvidersId("");
    readData();
  };

  const readServices = () => {
    API.get("/recharge-configurations/services").then((response) => {
      const { status, data } = response.data;
      if (status === API_RESPONSE_TYPES.SUCCESS) {
        setServices(data);
      }
    });
  };

  const readOperators = () => {
    API.get("/recharge-configurations/operators").then((response) => {
      const { status, data } = response.data;
      if (status === API_RESPONSE_TYPES.SUCCESS) {
        setOperators(data);
      }
    });
  };

  const readApiProviders = () => {
    API.get("/recharge-configurations/api-providers").then((response) => {
      const { status, data } = response.data;
      if (status === API_RESPONSE_TYPES.SUCCESS) {
        setApiProviders(data);
      }
    });
  };

  const readData = useCallback(
    (operatorsId = "", apiProvidersId = "") => {
      setIsLoading(true);
      setResponseStatus("");
      setResponseMessage("");
      API.get(
        `/recharge-configurations/api-switching/?pageNumber=${paginationData.pageNumber}&recordsPerPage=${paginationData.recordsPerPage}&fOperatorsId=${operatorsId}&fApiProvidersId=${apiProvidersId}`
      )
        .then((response) => {
          const { status, message, data, pageInfo } = response.data;
          if (shouldRedirect(data?.length, paginationData?.pageNumber)) {
            redirectToPageOne();
          } else {
            setApiSwitching(data);
            if (status === API_RESPONSE_TYPES.FAILURE) {
              setResponseStatus(status);
              setResponseMessage(message);
            } else {
              setTotalRecords(pageInfo.totalRecords);
            }
          }
        })
        .catch((error) => {
          setResponseStatus(API_RESPONSE_TYPES.FAILURE);
          setResponseMessage(error.message);
        })
        .finally(() => {
          setIsLoading(false);
        });
    },
    [paginationData]
  );

  const reloadData = () => {
    if (servicesId !== "" && operatorsId === "" && apiProvidersId === "") {
      alert("Please select operator or api provider");
    } else {
      readData(operatorsId, apiProvidersId);
    }
  };

  const deleteData = (id) => {
    setIsLoading(true);
    setResponseStatus("");
    setResponseMessage("");
    API.delete(
      `/recharge-configurations/api-switching/${id}?pageNumber=${paginationData.pageNumber}&recordsPerPage=${paginationData.recordsPerPage}&fOperatorsId=${operatorsId}&fApiProvidersId=${apiProvidersId}`
    )
      .then((response) => {
        const { status, message, data } = response.data;
        if (shouldRedirect(data?.length, paginationData?.pageNumber)) {
          redirectToPageOne();
        } else {
          if (status === API_RESPONSE_TYPES.FAILURE) {
            setResponseStatus(status);
            setResponseMessage(message);
          } else {
            setApiSwitching(data);
          }
        }
      })
      .catch((error) => {
        setResponseStatus(API_RESPONSE_TYPES.FAILURE);
        setResponseMessage(error.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const updateSwitchingProviders = () => {
    setIsLoading(true);
    setResponseStatus("");
    setResponseMessage("");
    API.post(`/recharge-configurations/api-switching/providers`, {
      switchingsId,
      switchingType,
      switchings,
      profitOnly,
      enableSwitchingBackup,
    })
      .then((response) => {
        const { status, message } = response.data;
        if (status === API_RESPONSE_TYPES.FAILURE) {
          setResponseStatus(status);
          setResponseMessage(message);
        } else {
          setResponseStatus(status);
          setResponseMessage(message);
          setTimeout(() => {
            reloadData();
            setResponseStatus("");
            setResponseMessage("");
            setShowModal(false);
            setSwitchingsId("");
            setSwitchingsObject(null);
            setSwitchingType("Dynamic");
            setEnableSwitchingBackup("Yes");
            setSwitchings([]);
          }, 3000);
        }
      })
      .catch((error) => {
        setResponseStatus(API_RESPONSE_TYPES.FAILURE);
        setResponseMessage(error.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const filterData = (e) => {
    e.preventDefault();
    if (servicesId !== "" && operatorsId === "" && apiProvidersId === "") {
      alert("Please select operator or api provider");
    } else {
      setIsFiltering(true);
    }
  };

  useEffect(() => {
    if (isFiltering) {
      setPaginationData((paginationData) => ({
        pageNumber: 1,
        recordsPerPage: paginationData.recordsPerPage,
      }));
      setIsFiltering((isFiltering) => !isFiltering);
    }
  }, [isFiltering]);

  useEffect(() => {
    readServices();
    readOperators();
    readApiProviders();
  }, []);

  useEffect(() => {
    if (!isFiltering) {
      readData(operatorsId, apiProvidersId);
    }
  }, [paginationData, readData]);

  const { accountsPermissions, subRoutes } = props;
  let updateLink = "";
  let updateTitle = "";
  const canUpdate =
    accountsPermissions.includes(PERMISSION_TYPES.UPDATE) || false;
  const canDelete =
    accountsPermissions.includes(PERMISSION_TYPES.DELETE) || false;
  if (canUpdate) {
    const { title, path } = subRoutes.find(
      ({ permissionRequired }) => permissionRequired === PERMISSION_TYPES.UPDATE
    );
    updateLink = path;
    updateTitle = title;
  }

  const servicesOptions = [{ title: "-- SELECT SERVICE --", value: "" }];
  services.forEach(({ id, serviceName }) =>
    servicesOptions.push({
      title: serviceName,
      value: id,
    })
  );

  const operatorsOptions = [{ title: "-- SELECT OPERATOR --", value: "" }];
  operators
    .filter((operator) =>
      servicesId !== "" ? operator.servicesId === servicesId : true
    )
    .forEach(({ id, operatorName }) =>
      operatorsOptions.push({
        title: operatorName,
        value: id,
      })
    );

  const apiProvidersOptions = [
    { title: "-- SELECT API PROVIDER --", value: "" },
  ];
  apiProviders.forEach(({ id, providerName }) =>
    apiProvidersOptions.push({
      title: providerName,
      value: id,
    })
  );

  const [showFilters, setShowFilters] = useState(false);
  const onClickShowFilters = () => {
    setShowFilters((showFilters) => !showFilters);
  };

  return (
    <>
      <PageHeading {...props} reloadData={reloadData} />
      <FiltersButton onClick={onClickShowFilters} value={showFilters} />
      <StyledFiltersContainer className={showFilters ? "show" : ""}>
        <Form method="POST" action="#" onSubmit={filterData}>
          <Fieldset>
            <Label>Service</Label>
            <Dropdown
              style={{ border: "1px solid #cacaca" }}
              placeholder="Service"
              value={servicesId}
              onChange={(value) => {
                setOperatorsId("");
                setServicesId(value);
              }}
              options={servicesOptions}
              disabled={isLoading}
            />
          </Fieldset>
          <Fieldset>
            <Label>Operator</Label>
            <Dropdown
              style={{ border: "1px solid #cacaca" }}
              placeholder="Operator"
              value={operatorsId}
              onChange={setOperatorsId}
              options={operatorsOptions}
              disabled={isLoading}
            />
          </Fieldset>
          {/* <Fieldset>
            <Label>API Provider</Label>
            <Dropdown
              style={{ border: '1px solid #cacaca' }}
              placeholder="API Provider"
              value={apiProvidersId}
              onChange={setApiProvidersId}
              options={apiProvidersOptions}
              disabled={isLoading}
            />
          </Fieldset> */}
          <Fieldset>
            <Button disabled={isLoading === true} type="submit">
              Filter
            </Button>
            <ResetButton
              disabled={isLoading === true}
              type="button"
              onClick={resetForm}
            >
              Clear
            </ResetButton>
          </Fieldset>
        </Form>
      </StyledFiltersContainer>
      <LoadingSpinner
        isLoading={
          responseStatus === "" && apiSwitching?.length === 0 && isLoading
        }
      />
      <NoData
        status={
          responseStatus !== API_RESPONSE_TYPES.FAILURE &&
          !isLoading &&
          apiSwitching?.length === 0
        }
        message={`No api switchings found`}
      />
      {responseStatus === API_RESPONSE_TYPES.FAILURE && (
        <MessageBox status={responseStatus} message={responseMessage} />
      )}
      {apiSwitching?.length > 0 && (
        <>
          <TableBuilder
            isLoading={apiSwitching?.length !== 0 && isLoading}
            tableHeadings={[
              {
                title: "",
                dataSelector: "id",
                sticky: true,
                canSort: false,
                width: "100px",
                CellRenderer: (value, item) => (
                  <>
                    {canUpdate && (
                      <StyledLink
                        to={updateLink.replace(":id", value)}
                        title={updateTitle}
                      >
                        <FontAwesomeIcon icon={faEdit} />
                      </StyledLink>
                    )}
                    {canDelete && (
                      <CustomConfirmButton onClick={() => deleteData(value)} />
                    )}
                    {accessType === "V2" && (
                      <CustomButton
                        icon={faCodeBranch}
                        onClick={() => {
                          setProfitOnly(
                            item?.switchings?.length > 0
                              ? item?.switchings[0]?.profitOnly
                              : "No"
                          );
                          setSwitchingsId(value);
                          setSwitchingsObject(item);
                          setSwitchingType("Dynamic");
                          setEnableSwitchingBackup(
                            item?.switchings?.length > 0
                              ? item?.switchings[0]?.enableSwitchingBackup
                              : "Yes"
                          );
                          setSwitchings(item?.switchings || []);
                          setShowModal(true);
                        }}
                        style={{ color: "#333f7a" }}
                      />
                    )}
                  </>
                ),
              },
              {
                title: "Operator",
                dataSelector: "operatorName",
                dataType: "string",
                canSort: false,
                CellRenderer: (value, item) => (
                  <StyledIconTitleContainer>
                    <StyledIconContainer>
                      <Image
                        source={
                          item.operatorLogo
                            ? item.operatorLogo
                            : "/no-image.png"
                        }
                        alt={value}
                        style={{ width: "50px", height: "50px" }}
                      />
                    </StyledIconContainer>
                    <StyledTitleContainer>
                      {value}
                      <StyledSpan>{item.serviceName}</StyledSpan>
                    </StyledTitleContainer>
                  </StyledIconTitleContainer>
                ),
              },
              // {
              //   title: 'Circles Name',
              //   dataSelector: 'circleName',
              //   dataType: 'string',
              // },
              {
                title: "From Amount",
                dataSelector: "fromAmount",
                dataType: "number",
                CellRenderer: (value) => formatCurrency(value),
              },
              {
                title: "To Amount",
                dataSelector: "toAmount",
                dataType: "number",
                CellRenderer: (value) => formatCurrency(value),
              },
              // {
              //   title: 'Routing Mode',
              //   dataSelector: 'routingMode',
              //   dataType: 'string',
              // },
              {
                title: "Primary API Provider",
                dataSelector: "primaryApiProvidersName",
                dataType: "string",
                shouldShow: accessType === "V1",
              },
              {
                title: "Secondary API Provider",
                dataSelector: "secondaryApiProvidersName",
                dataType: "string",
                shouldShow: accessType === "V1",
              },
              {
                title: "Tertiary API Provider",
                dataSelector: "tertiaryApiProvidersName",
                dataType: "string",
                shouldShow: accessType === "V1",
              },
            ]}
            tableData={apiSwitching}
          />
          <Pagination
            totalRecords={totalRecords}
            paginationData={paginationData}
            setPaginationData={setPaginationData}
          />
          <Modal
            modalStatus={showModal}
            setModalStatus={() => {
              setProfitOnly("No");
              setSwitchingsId("");
              setSwitchingsObject(null);
              setSwitchingType("Dynamic");
              setEnableSwitchingBackup("Yes");
              setSwitchings([]);
              setShowModal(false);
            }}
            hideCloseButton
          >
            <StyledModalContainer width={`1200px`}>
              <h3>Select API Providers</h3>
              <StyledApiCallLogsContainer>
                {/* <Grid columns={'calc(50% - 10px) calc(50% - 10px)'}>
                  <GridItem>
                    <Fieldset>
                      <Label>Operator : {switchingsObject?.operatorName}</Label>
                    </Fieldset>
                  </GridItem>
                  <GridItem>
                    <Fieldset>
                      <Label>
                        Circle :{' '}
                        {switchingsObject?.circleName
                          ? switchingsObject?.circleName
                          : 'All'}
                      </Label>
                    </Fieldset>
                  </GridItem>
                </Grid>
                <Grid columns={'calc(50% - 10px) calc(50% - 10px)'}>
                  <GridItem>
                    <Fieldset>
                      <Label>
                        From Amount :{' '}
                        {switchingsObject?.fromAmount ||
                        switchingsObject?.fromAmount === 0
                          ? formatCurrency(switchingsObject?.fromAmount)
                          : 'N/A'}
                      </Label>
                    </Fieldset>
                  </GridItem>
                  <GridItem>
                    <Fieldset>
                      <Label>
                        To Amount :
                        {switchingsObject?.toAmount ||
                        switchingsObject?.toAmount === 0
                          ? formatCurrency(switchingsObject?.toAmount)
                          : 'N/A'}
                      </Label>
                    </Fieldset>
                  </GridItem>
                </Grid> */}
                {apiProviders?.length === 0 && (
                  <NoData
                    status={
                      responseStatus !== API_RESPONSE_TYPES.FAILURE &&
                      !isLoading &&
                      apiProviders?.length === 0
                    }
                    message={`No api providers found`}
                  />
                )}

                {apiProviders?.length > 0 && (
                  <>
                    {/* <Fieldset>
                      <Label required>Profit Only ?</Label>
                      <Dropdown
                        placeholder="Please select profit only"
                        value={profitOnly}
                        onChange={setProfitOnly}
                        options={[
                          {
                            title: '-- SELECT PROFIT ONLY --',
                            value: '',
                          },
                          {
                            title: 'Yes',
                            value: 'Yes',
                          },
                          {
                            title: 'No',
                            value: 'No',
                          },
                        ]}
                        disabled={isLoading}
                      />
                    </Fieldset> */}
                    {/* <Fieldset>
                      <Label required>Routing Mode</Label>
                      <Dropdown
                        placeholder="Please select switching type"
                        value={switchingType}
                        onChange={(value) => {
                          setSwitchingType(value);
                          setEnableSwitchingBackup('Yes');
                        }}
                        options={[
                          {
                            title: '-- SELECT SWITCHING TYPE --',
                            value: '',
                          },
                          {
                            title: 'Dynamic',
                            value: 'Dynamic',
                          },
                          {
                            title: 'Backup',
                            value: 'Backup',
                          },
                        ]}
                        disabled={isLoading}
                      />
                    </Fieldset> */}
                    <Fieldset>
                      <Label required>Enable Backup?</Label>
                      <Dropdown
                        placeholder="Please select backup status"
                        value={enableSwitchingBackup}
                        onChange={setEnableSwitchingBackup}
                        options={[
                          {
                            title: "-- SELECT BACKUP STATUS --",
                            value: "",
                          },
                          {
                            title: "Yes",
                            value: "Yes",
                          },
                          {
                            title: "No",
                            value: "No",
                          },
                        ]}
                        disabled={switchingType === "Backup" || isLoading}
                      />
                    </Fieldset>
                    <Grid
                      columns={
                        "calc(33.33% - 13.33px) calc(33.33% - 13.33px) calc(33.33% - 13.33px)"
                      }
                    >
                      <GridItem>
                        <Fieldset>
                          <TextInput
                            value={searchValue}
                            onChange={setSearchValue}
                            placeholder="Search API Providers"
                            disabled={isLoading}
                            width="300px"
                          />
                        </Fieldset>
                      </GridItem>
                    </Grid>
                    <TableBuilder
                      isLoading={apiProviders?.length !== 0 && isLoading}
                      tableData={
                        searchValue && !isEmpty(searchValue)
                          ? apiProviders.filter(
                              (item) =>
                                item?.providerName
                                  ?.toString()
                                  ?.toLowerCase()
                                  ?.search(
                                    searchValue?.toString()?.toLowerCase()
                                  ) !== -1
                            )
                          : apiProviders
                      }
                      tableHeadings={[
                        {
                          title: "",
                          dataSelector: "id",
                          canSort: false,
                          width: "50px",
                          isHeaderCheckBox: true,
                          onClickCheckBox: () => {
                            if (apiProviders.length === switchings.length) {
                              setSwitchings([]);
                            } else {
                              setSwitchings(
                                apiProviders.map(({ id }) => {
                                  const switching = switchings.findIndex(
                                    (item) => item.apiProvidersId === id
                                  );
                                  if (switching && switching !== -1) {
                                    return {
                                      ...switching,
                                    };
                                  } else {
                                    return {
                                      switchingsId,
                                      apiProvidersId: id,
                                      numberValue: "",
                                    };
                                  }
                                })
                              );
                            }
                          },
                          isAllSelected:
                            apiProviders.length === switchings.length,
                          CellRenderer: (value) => {
                            const switching = switchings.find(
                              (item) => item?.apiProvidersId === value
                            );
                            return (
                              <TextInput
                                type="checkbox"
                                checked={switching && switching !== -1}
                                onChange={() => {
                                  if (switching && switching !== -1) {
                                    const newSwitchings = [...switchings];
                                    setSwitchings(
                                      newSwitchings.filter(
                                        (item) => item.apiProvidersId !== value
                                      )
                                    );
                                  } else {
                                    const newSwitchings = [...switchings];
                                    newSwitchings.push({
                                      switchingsId,
                                      apiProvidersId: value,
                                      numberValue: "",
                                    });
                                    setSwitchings(newSwitchings);
                                  }
                                }}
                              />
                            );
                          },
                        },
                        {
                          title: "API Provider",
                          dataSelector: "providerName",
                          canSort: false,
                        },
                        {
                          title:
                            switchingType === "Backup"
                              ? "Back Up Sequence"
                              : switchingType === "Dynamic"
                              ? "Number of Hits"
                              : "",
                          dataSelector: "id",
                          canSort: false,
                          width: "250px",
                          CellRenderer: (value) => {
                            const switching = switchings.find(
                              (item) => item?.apiProvidersId === value
                            );
                            return (
                              <NumberInput
                                value={switching?.numberValue || ""}
                                onChange={(value2) => {
                                  const newSwitchings = [...switchings];
                                  const switchingIndex = [
                                    ...switchings,
                                  ].findIndex(
                                    (item) => item.apiProvidersId === value
                                  );
                                  newSwitchings[switchingIndex].numberValue =
                                    value2;
                                  setSwitchings(newSwitchings);
                                }}
                                disabled={
                                  !switching || switching === -1 || isLoading
                                }
                                placeholder={`Please enter ${
                                  switchingType === "Backup"
                                    ? "sequence"
                                    : switchingType === "Dynamic"
                                    ? "number of hits"
                                    : "value"
                                }`}
                              />
                            );
                          },
                        },
                      ]}
                    />
                    <OverlayLoader
                      showLoader={
                        responseStatus === "" &&
                        apiProviders?.length === 0 &&
                        isLoading
                      }
                    />
                    <Fieldset>
                      <MessageBox
                        status={responseStatus}
                        message={responseMessage}
                      />
                    </Fieldset>
                    <Fieldset>
                      <Button onClick={updateSwitchingProviders}>Save</Button>
                    </Fieldset>
                  </>
                )}
              </StyledApiCallLogsContainer>
            </StyledModalContainer>
          </Modal>
        </>
      )}
    </>
  );
};

export default withAppHOC(APISwitchingTable);
